import { memo } from "react";

import { tw } from "classnames";

const styles = {
  base: tw("w-full", "h-full", "bg-placeholder", "animate-pulse"),
};

const CollectionHeroImagePlaceholderBase = () => {
  return <div className={styles.base} />;
};

export const CollectionHeroImagePlaceholder = memo(
  CollectionHeroImagePlaceholderBase
);
